import { WHeading } from '@alice-health/wonderland-react'
import { WHeadingComponentProps } from '@alice-health/wonderland'
import { PropsWithChildren } from 'react'
import { ClassName } from '@/types'

interface WHeadingWrapperProps extends Partial<WHeadingComponentProps> {
  className?: ClassName
}
export const WHeadingWrapper = ({
  children,
  ...props
}: PropsWithChildren<WHeadingWrapperProps>) => {
  return <WHeading {...props}>{children}</WHeading>
}
